import {
  RESEND_PASSWORD_BEGIN,
  RESEND_PASSWORD_SUCCESS,
  RESEND_PASSWORD_FAILURE,
  GENERIC_ERROR_MESSAGE
} from "./types";
import API from "../../../../../Services/API";
import { ENDPOINTS } from "utils/endpoints";
import { checkAMLob } from "utils/checkAMLob";

import { history } from "../../../Layout";
import { fetchProfileAPI, checkIfMDNisSMSCapable } from "./index";

export const resendPassword = uniqueTxnId => async dispatch => {
  dispatch({ type: RESEND_PASSWORD_BEGIN });

  try {
    const response = await API({
      url: ENDPOINTS.RESEND_PASSWORD,
      method: "POST",
      data: {
        uniqueTxnId
      }
    });

    if (response && response.status === "OK") {
      dispatch({
        type: RESEND_PASSWORD_SUCCESS,
        payload: response.data
      });
    } else {
      dispatch({ type: RESEND_PASSWORD_FAILURE, payload: GENERIC_ERROR_MESSAGE });
    }
  } catch (error) {
    if (error.response && error.response.hasOwnProperty("description")) {
      dispatch({
        type: RESEND_PASSWORD_FAILURE,
        payload: error.response.description
      });
    } else {
      dispatch({
        type: RESEND_PASSWORD_FAILURE,
        payload: GENERIC_ERROR_MESSAGE
      });
    }
  }
};

export const resendPasswordBegin = returnRoute => async(dispatch, getState) => {
  const next = () =>
    history.push({
      pathname: "multifactor-authentication-primer",
      state: {
        confirmAuth: true,
        resendPWFlow: true,
        nextRoute: "resend-password-success",
        returnRoute
      }
    });

  if (checkAMLob() === "vzw") {
    dispatch(fetchProfileAPI()).then(() => {
      const loggedInMdn = getState().profileInformation.find(
        item => item.mtn === window.reactGlobals.loggedInMdn
      );

      if (!getState().loadingAndErrorState.error) {
        dispatch(
          checkIfMDNisSMSCapable(loggedInMdn && loggedInMdn.encryptedMtn ? loggedInMdn.encryptedMtn : "")
        ).then(() => {
          if (!getState().loadingAndErrorState.error) {
            next();
          }
        });
      }
    });
  } else {
    next();
  }
};


export const downloadResendPassword = uniqueTxnId => async dispatch => {
  dispatch({ type: RESEND_PASSWORD_BEGIN });

  try {
    const response = await API({
      url: ENDPOINTS.RESEND_PASSWORD_KEY,
      method: "POST",
      data: {
        uniqueTxnId
      }
    });

    if (response && response.status === "OK") {
      const payload = {
        ...response.data
      };
      if (response.data && response.data.key) {
        payload.key = response.data.key;
      }
      dispatch({
        type: RESEND_PASSWORD_SUCCESS,
        payload
      });
    } else {
      dispatch({ type: RESEND_PASSWORD_FAILURE, payload: GENERIC_ERROR_MESSAGE });
    }
  } catch (error) {
    if (error.response && error.response.hasOwnProperty("description")) {
      dispatch({
        type: RESEND_PASSWORD_FAILURE,
        payload: error.response.description
      });
    } else {
      dispatch({
        type: RESEND_PASSWORD_FAILURE,
        payload: GENERIC_ERROR_MESSAGE
      });
    }
  }
};